"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStudentDetailedPerformance = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStudentDetailedPerformance = styled_components_1.default.tr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: solid ", "\n    ", ";\n  cursor: ", ";\n\n  button:disabled {\n    color: #1f2226 !important;\n  }\n\n  td,\n  th {\n    text-align: center;\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    padding: ", " ", ";\n\n    &.overall {\n      > div {\n        ", ";\n      }\n    }\n\n    .badge-container {\n      border: none;\n      background-color: inherit;\n      display: inline-block;\n    }\n\n    &:first-child {\n      font-weight: bold;\n    }\n\n    &.hide {\n      display: none;\n    }\n\n    &.name {\n      text-align: start;\n      white-space: pre-wrap;\n\n      button {\n        font-weight: bold;\n      }\n    }\n  }\n"], ["\n  border-bottom: solid ", "\n    ", ";\n  cursor: ", ";\n\n  button:disabled {\n    color: #1f2226 !important;\n  }\n\n  td,\n  th {\n    text-align: center;\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    padding: ", " ", ";\n\n    &.overall {\n      > div {\n        ", ";\n      }\n    }\n\n    .badge-container {\n      border: none;\n      background-color: inherit;\n      display: inline-block;\n    }\n\n    &:first-child {\n      font-weight: bold;\n    }\n\n    &.hide {\n      display: none;\n    }\n\n    &.name {\n      text-align: start;\n      white-space: pre-wrap;\n\n      button {\n        font-weight: bold;\n      }\n    }\n  }\n"])), function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.x1;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.disabled;
}, function (_a) {
    var average = _a.average;
    return (average ? 'auto' : 'pointer');
}, function (_a) {
    var average = _a.average, Colors = _a.theme.Colors;
    return "".concat(average ? Colors.Backgrounds.subtle : Colors.white);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
});
var templateObject_1;
